import { render, staticRenderFns } from "./StartNewEvaluation.vue?vue&type=template&id=6138317d"
import script from "./StartNewEvaluation.vue?vue&type=script&lang=js"
export * from "./StartNewEvaluation.vue?vue&type=script&lang=js"
import style0 from "./StartNewEvaluation.vue?vue&type=style&index=0&id=6138317d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports